export enum CmsActionTypes {
  CMS_CONTENT_CHANGED = "CMS_CONTENT_CHANGED",
}
